import React from "react";

import { IBlock } from "../../../types/IBlock";
import { IContentfulBackgroundColour } from "../../../types/IContentfulBackgroundColour";
import { ICTA } from "../../../types/ICTA";
import { IContentfulRichTextResponse } from "../../../types/IContentfulRichText";
import { EVersions, IPullOutBlocksVariants } from "../../../types/common";

import { PullOutBlocksPanelOriginal } from "./variants/Original";
import { PullOutBlocksPanelLite } from "./variants/Lite";
import { PullOutBlocksPanelCardsWithOverlay } from "./variants/CardsWithOverlay";
import { PullOutBlocksPanelGuides } from "./variants/Guides";
import { PullOutBlocksPanelBetterV2Cards } from "./variants/BetterV2Cards";

export interface IPullOutBlocksPanelProps {
  title?: string;
  variant: IPullOutBlocksVariants;
  bgColour: IContentfulBackgroundColour;
  blocks: IBlock[];
  content?: IContentfulRichTextResponse;
  callToActions?: ICTA[];
  headerAnchor?: string;
  version: EVersions;
}

export const PullOutBlocksPanel: React.FC<IPullOutBlocksPanelProps> = ({
  bgColour, blocks, variant, version, callToActions, content, headerAnchor, title,
}) => {
  switch (variant) {
    case "cardsWithOverlay": {
      return PullOutBlocksPanelCardsWithOverlay({ blocks, title, callToActions });
    }
    case "lite": {
      return PullOutBlocksPanelLite({ blocks });
    }
    case "betterV2": {
      return PullOutBlocksPanelGuides({ bgColour, blocks, title });
    }
    case "betterV2Cards": {
      return PullOutBlocksPanelBetterV2Cards({
        blocks, content, title,
      });
    }
    case "original":
    default: {
      return PullOutBlocksPanelOriginal({
        bgColour, blocks, content, callToActions, version, headerAnchor,
      });
    }
  }
};
